var exports = {
  "Jm": "CommunityFooter__cRboXI",
  "c8": "CommunityFooter__header__jVdD3_",
  "jM": "CommunityFooter__body__K7IAon",
  "Jj": "CommunityFooter__hero__TZD-PL",
  "jw": "CommunityFooter__label__4RXAr-",
  "Xm": "CommunityFooter__heading__nSCsTX",
  "Nu": "CommunityFooter__signUpForm__1c3WTM",
};

module.exports = exports;
